import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import LandingPage from './pages/LandingPage';
import AdminLogin from './pages/auth/AdminLogin';
import UserLogin from './pages/auth/UserLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserDashboard from './pages/user/UserDashboard';

import './App.css';

function ProtectedRoute({ children, requiredType }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"></div></div>;
  if (!user) {
    return <Navigate to={requiredType === 'admin' ? '/admin/login' : '/user/login'} replace />;
  }
  if (requiredType && user.type !== requiredType) {
    return <Navigate to={user.type === 'admin' ? '/admin/dashboard' : '/user/dashboard'} replace />;
  }
  return children;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/" element={
        user ? (
          user.type === 'admin' ? <Navigate to="/admin/dashboard" replace /> : <Navigate to="/user/dashboard" replace />
        ) : <LandingPage />
      } />
      <Route path="/admin" element={
        user?.type === 'admin' ? <Navigate to="/admin/dashboard" replace /> : <AdminLogin />
      } />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/user/login" element={<UserLogin />} />
      <Route path="/admin/*" element={
        <ProtectedRoute requiredType="admin">
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/user/*" element={
        <ProtectedRoute requiredType="user">
          <UserDashboard />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { fontFamily: 'Inter, sans-serif' },
            success: { iconTheme: { primary: '#16a34a', secondary: '#fff' } },
          }}
        />
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
